(() => {
  'use strict';
  let translations = {};
  try { translations = JSON.parse(document.getElementById('StorefrontTranslations')?.textContent || '{}'); } catch (_) {}
  const t = (key, values = {}, fallback = key) => {
    const value = key.split('.').reduce((object, part) => object && Object.prototype.hasOwnProperty.call(object, part) ? object[part] : undefined, translations);
    return String(typeof value === 'string' ? value : fallback).replace(/\{([a-zA-Z_][\w]*)\}/g, (match, name) => Object.prototype.hasOwnProperty.call(values, name) ? String(values[name]) : match);
  };
  window.NLV = window.NLV || {};
  window.NLV.i18n = { t };
})();
